import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { useTranslation } from "../i18n";
import { useConfig } from "../_util/config-context";
export var FoundTip = React.forwardRef(function FoundTip(props, ref) {
    var classPrefix = useConfig().classPrefix;
    var t = useTranslation();
    var _a = props.foundText, foundText = _a === void 0 ? t.foundText : _a, _b = props.clearResultText, clearResultText = _b === void 0 ? t.clearResultText : _b, onClear = props.onClear, className = props.className, restProps = __rest(props, ["foundText", "clearResultText", "onClear", "className"]);
    return (React.createElement("span", __assign({ ref: ref, className: classNames(classPrefix + "-action-state", className) }, restProps),
        typeof foundText === "string" ? (React.createElement("span", { className: classPrefix + "-action-state__text", title: foundText }, foundText)) : (foundText),
        onClear && (React.createElement(React.Fragment, null,
            " ",
            React.createElement("a", { className: classPrefix + "-action-state__text " + classPrefix + "-ml-1n", onClick: onClear }, clearResultText)))));
});
FoundTip.displayName = "FoundTip";
//# sourceMappingURL=FoundTip.js.map